class TabbedBlog extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll(".tabbed-blog__panel");
    this.seeAllDesktop = this.querySelector("[data-see-all-desktop]");
    this.seeAllMobile = this.querySelector("[data-see-all-mobile]");

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.onTab.bind(this));
    });

    // Hide see-all on initial load (All tab is active by default)
    this.setSeeAll(null);
  }

  setSeeAll(href) {
    const show = !!href;
    if (this.seeAllDesktop) {
      this.seeAllDesktop.style.visibility = show ? "" : "hidden";
      if (show) this.seeAllDesktop.href = href;
    }
    const mobileWrap = this.querySelector(".tabbed-blog__mobile-see-all");
    if (mobileWrap) mobileWrap.style.display = show ? "" : "none";
    if (this.seeAllMobile && show) this.seeAllMobile.href = href;
  }

  onTab(e) {
    const tab = e.currentTarget;
    const panelId = tab.dataset.tab;
    const seeAll = tab.dataset.seeAll || null;

    // Update tab states
    this.tabs.forEach((t) => {
      const active = t === tab;
      t.setAttribute("aria-selected", active ? "true" : "false");
      t.classList.toggle("is-active", active);
    });

    // Update panel visibility
    this.panels.forEach((panel) => {
      const active = panel.dataset.panel === panelId;
      panel.classList.toggle("is-active", active);
    });

    // Show/hide see-all based on whether the tab has a blog URL
    this.setSeeAll(seeAll);
  }
}

customElements.define("tabbed-blog", TabbedBlog);
